import { CustomModal, FormEntry } from "components";
import { Row, Col } from "reactstrap";

export const LeaveOrOTDetailsPage = ({
    open,
    hide,
    event,
    register,
    editable,
}) => (
    <CustomModal
        show={open}
        hideModal={hide}
        light={true}
        title={event?.isOt ? "OT Details" : "Leave Details"}
    >
        <Row>
            <Col xs={12} sm={12}>
                <FormEntry
                    labelSize="lg"
                    formLabel="Staff Name"
                    register={register}
                    name="date"
                    type="date"
                    required={true}
                    readOnly={!editable}
                    editable={false}
                    alt={event?.staff?.fullName}
                />
            </Col>
            <Col xs={12} sm={12}>
                <FormEntry
                    labelSize="lg"
                    formLabel={event?.isOt ? "OT Date" : "Leave Date"}
                    register={register}
                    name="date"
                    type="date"
                    required={true}
                    readOnly={!editable}
                    editable={false}
                    alt={event?.date}
                />
            </Col>
            <Col xs={12} sm={12}>
                <FormEntry
                    labelSize="lg"
                    formLabel="Type"
                    register={register}
                    name="type"
                    type="text"
                    required={true}
                    readOnly={!editable}
                    editable={false}
                    alt={event?.type}
                />
            </Col>
            {event?.period === "FD" || event?.period === "HD" ? (
                <Col xs={12} sm={12}>
                    <FormEntry
                        labelSize="lg"
                        formLabel="Period"
                        register={register}
                        name="period"
                        type="time"
                        required={true}
                        readOnly={!editable}
                        editable={false}
                        alt={event?.period}
                    />
                </Col>
            ) : (
                <>
                    <Col xs={12} sm={12}>
                        <FormEntry
                            labelSize="lg"
                            formLabel="Start Time"
                            register={register}
                            name="startTime"
                            type="time"
                            required={true}
                            editable={false}
                            alt={event?.startTime}
                        />
                    </Col>
                    <Col xs={12} sm={12}>
                        <FormEntry
                            labelSize="lg"
                            formLabel="End Time"
                            register={register}
                            name="endTime"
                            type="time"
                            required={true}
                            editable={false}
                            alt={event?.endTime}
                        />
                    </Col>
                </>
            )}
        </Row>
    </CustomModal>
);
